import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from '../../services/common-data.service';

@Component({
  selector: 'app-glossary-term-topic',
  templateUrl: './glossary-term-topic.component.html'
})
export class GlossaryTermTopicComponent implements OnInit {

  @Output() myEvent = new EventEmitter<string>();
  @Input() GlossaryTermData:any=[];
  topicData:any=[];
  topic:string="";
  
  constructor(private commonDataService:CommonDataService, private route:Router) { }

  ngOnInit(): void {
    this.topicData=this.GlossaryTermData;
    this.topic=this.topicData.topic+" "+this.topicData.topicName
  }
  
  navigateToContent() {
    this.route.navigateByUrl("94389/2147483597/presentation/status");
    this.myEvent.emit();
  }

  ngOnDestroy():void{
    this.commonDataService.glossaryTermData.next([]);
  }
}
